// extracted by mini-css-extract-plugin
export default {"cardYear":"_7AD2K","textContainer":"eG73Y","title":"DWVkF","active":"ibvHy"};